import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Card, CardContent, Chip, Stack, Typography } from '@mui/material';
import api from '../services/api';

export default function AiStatusPanel() {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const refresh = async () => {
    setLoading(true);
    setError('');
    try {
      const status = (await api.get('/ai/status')).data;
      let usage = null;
      let usageError = '';
      let reviews = [];
      try { usage = (await api.get('/ai/usage')).data; }
      catch (_) { usageError = 'Consumi non disponibili.'; }
      try { reviews = (await api.get('/ai/reviews')).data.results || []; } catch (_) {}
      setData({ status, usage, usageError, reviews });
    } catch (_) { setError('Impossibile caricare lo stato IA.'); }
    finally { setLoading(false); }
  };
  useEffect(() => { refresh(); }, []);
  return (
    <Card sx={{ mb: 3 }}>
      <CardContent>
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h6">Assistente IA · Luna</Typography>
          <Button onClick={refresh} disabled={loading}>Aggiorna stato</Button>
        </Stack>
        {error && <Alert severity="warning">{error}</Alert>}
        {data && <>
          <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" sx={{ my: 1 }}>
            <Chip label={data.status.available ? 'Configurato' : 'Non attivo'} color={data.status.available ? 'success' : 'default'} />
            <Chip label={`Analisi automatica email: ${data.status.automatic?.email ? 'attiva' : 'spenta'}`} />
            <Chip label={`Analisi automatica WhatsApp: ${data.status.automatic?.whatsapp ? 'attiva' : 'spenta'}`} />
          </Stack>
          <Typography variant="body2">{data.status.message}</Typography>
          <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" sx={{ my: 1 }}>
            {Object.entries({ id_document: 'Documenti', meter_photo: 'Foto contatori', reconciliation: 'Riconciliazione', chat: 'Chat' }).map(([key, label]) => <Chip key={key} label={`${label}: ${data.status.features?.[key] ? 'abilitato' : 'spento'}`} size="small" />)}
          </Stack>
          {data.reviews.length > 0 && <Box sx={{ my: 1 }}><Typography variant="subtitle2">Valutazioni degli operatori</Typography>
            {data.reviews.map(row => <Typography variant="body2" key={`${row.feature}-${row.verdict}`}>{row.feature} · {row.verdict === 'correct' ? 'corrette' : 'da correggere'}: {row.count}</Typography>)}
            <Typography variant="caption">Le valutazioni non attivano automaticamente gli invii o le analisi periodiche.</Typography>
          </Box>}
          {data.usage && <Box sx={{ mt: 1 }}>
            <Typography variant="body2">
              Consumo stimato del tenant ({data.usage.month}): ${Number(data.usage.estimatedUsd).toFixed(4)}
              {' / $'}{data.usage.tenantMonthlyBudgetUsd} · Limite globale: ${data.usage.globalMonthlyBudgetUsd}/mese
            </Typography>
            <Typography variant="caption" color="text.secondary">Il conteggio comprende le aziende di questo tenant. I limiti sono configurati sul server; non rappresentano il credito del conto OpenAI.</Typography>
          </Box>}
          {data.usageError && <Alert severity="info" sx={{ mt: 1 }}>{data.usageError}</Alert>}
        </>}
      </CardContent>
    </Card>
  );
}
